module.exports = __webpack_public_path__ + "img/charging-table.0ea731e6.png";